import React, { Fragment, useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useDropzone } from 'react-dropzone';
import Icon from 'react-icons-kit';
import { close } from 'react-icons-kit/fa';
import { connect } from 'react-redux';
import { CUSTOMER_PRIORITY_IMPORT_REQUEST } from "../../../../_utils/constants/CustomerPriority";

const ImportPriority = ({
	auth: { auth },
	CustomerPriority: { isLoading, isImported, importResult },
	importModalOpen,
	showImportModal,
	hideImportModal,
	importStoreId,
	submitImportPriority
}) => {

	// states declarations
	const [myFiles, setMyFiles] = useState([]);

	// dropzone initialization function
	const { getRootProps, getInputProps, inputRef } = useDropzone({
		accept: {
			'text/csv': ['.csv'],
			'application/vnd': ['.xls', '.xlsx']
		},
		onDrop: acceptedFiles => {
			acceptedFiles.map(file => setMyFiles(myFiles => [...myFiles, Object.assign(file)]))
		}
	});

	// function to remove a file from uploaded file list
	const removeFile = (file) => () => {
		const newFiles = [...myFiles];
		newFiles.splice(newFiles.indexOf(file), 1);
		setMyFiles(newFiles);
	}

	// function to remove all uploaded files
	const removeAll = () => {
		setMyFiles([]);
		inputRef.current.value = '';
	}

	// function called on file uploads
	const files = myFiles.map(file => (
		<li key={file.path} className="mb-2">
			{file.path} <Icon role='button' className="float-end" onClick={removeFile(file)} size={16} icon={close} />
		</li>
	));

	const handleImportSubmit = (e) => {
		e.preventDefault();
		var formdata = new FormData();
		formdata.append("StoreId", importStoreId);
		formdata.append("UserId", auth[0].userId);
		myFiles.map((item) => (
			formdata.append("file", item, item.name)
		))
		submitImportPriority({
			'token': auth[0].token,
			'data': formdata
		});
	}

	useEffect(() => {
		if (isImported === true) {
			removeAll();
		}
	}, [isImported])

	return (
		<Fragment>
			<Button className="btn-sm" variant="primary" onClick={showImportModal}>
				Import CSV
			</Button>
			<Modal show={importModalOpen} size="md">
				<Form onSubmit={handleImportSubmit}>
					<Modal.Header>
						<Modal.Title>Import Customer Priority</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<section className="container">
							<div {...getRootProps({ className: 'dropzone-style' })}>
								<input {...getInputProps()} />
								<p>Drag &apos;n&apos; drop some files here, or click to select files</p>
								<em>(Only *.xls, *.xlsx and *.csv files will be accepted)</em>
							</div>
							{files.length > 0 && (
								<div>
									<aside className="mt-3">
										<Row>
											<Col xs="8">
												<h5>Uploaded Files</h5>
											</Col>
											<Col xs="4">
												<div role="button" className="float-end" onClick={removeAll}>Remove All</div>
											</Col>
										</Row>
										<ul>{files}</ul>
									</aside>
								</div>
							)}
							{isImported && importResult && (
								<aside className="mt-3">
									{importResult.length > 0 && (
										<>
											<Row>
												<Col>
													<h6>Imported: {importResult[0].totalImported || 0}</h6>
												</Col>
											</Row>
											<Row>
												<Col>
													<h6>Skipped (no match): {importResult[0].totalSkipped || 0}</h6>
												</Col>
											</Row>
											{importResult[0].totalDuplicated !== undefined && (
												<Row>
													<Col>
														<h6>Duplicates removed: {importResult[0].totalDuplicated || 0}</h6>
													</Col>
												</Row>
											)}
										</>
									)}
								</aside>
							)}
						</section>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={hideImportModal}>
							Close
						</Button>
						{isLoading ? (
							<Button variant="primary" type="button">
								<div className="spinner-border"></div>
							</Button>
						) : (
							<Button variant="primary" type="submit">
								Save
							</Button>
						)}
					</Modal.Footer>
				</Form>
			</Modal>
		</Fragment>
	)
};

const mapStateToProps = ({ auth, CustomerPriority }) => {
	return {
		auth,
		CustomerPriority
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitImportPriority: (data) => dispatch({ type: CUSTOMER_PRIORITY_IMPORT_REQUEST, payload: data })
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportPriority);
